<template>
	<Teleport to="body">
		<div class="modal" :class="{ 'is-active': show }">
			<div class="modal-background" @click="close"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">{{ editingItem ? 'Edit item' : 'Add new item' }}</p>
					<button class="delete" aria-label="close" @click="close"></button>
				</header>
				<section class="modal-card-body">
					<div class="field">
						<label class="label">Images</label>
						<image-manager v-model:existing-src="existingImages" v-model:new-images="newImages"></image-manager>
					</div>
					<div class="field">
						<label class="label">Version</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select v-model="version">
									<option v-for="v in versions" :key="v">{{ v }}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="field" v-if="version !== 'Demos'">
						<label class="label">Country</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select v-model="country">
									<option value="">Unknown</option>
									<option v-for="c in countries" :key="c.name" :value="c.name">{{ c.name }}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="field" v-if="version !== 'Demos'">
						<label class="label">EAN</label>
						<div class="control">
							<input class="input" type="text" v-model="ean" @keyup.enter="submit" />
						</div>
					</div>
					<div class="field">
						<label class="label">Owned</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select v-model="own">
									<option value="true">Yes</option>
									<option value="soon">On the way</option>
									<option value="false">No</option>
								</select>
							</div>
						</div>
					</div>
					<p class="help is-danger" v-if="error">{{ error }}</p>
					<p class="help is-danger" v-if="submitError">{{ submitError }}</p>
				</section>
				<footer class="modal-card-foot">
					<button class="button is-success" :class="{ 'is-loading': isSubmitting }" :disabled="isSubmitting" @click="submit">
						{{ editingItem ? 'Save' : 'Add' }}
					</button>
					<button class="button" @click="close">Cancel</button>
				</footer>
			</div>
		</div>
	</Teleport>
</template>

<script>
import COUNTRIES from '@/countries.js';
import ImageManager from '@/components/ImageManager.vue';

export default {
	name: 'AddVirtualSkipperModal',
	components: { ImageManager },
	props: {
		show: Boolean,
		editingItem: { type: Object, default: null },
		versions: { type: Array, required: true },
		defaultVersion: { type: String, default: '' },
		onSubmit: { type: Function, required: true },
	},
	emits: ['close'],
	data() {
		return {
			countries: COUNTRIES,
			existingImages: [],
			newImages: [],
			version: this.versions[0],
			country: '',
			ean: '',
			own: 'true',
			error: '',
			isSubmitting: false,
			submitError: '',
		};
	},
	watch: {
		show(val) {
			if (val) this.populate();
		},
	},
	methods: {
		populate() {
			this.reset();
			if (this.editingItem) {
				const it = this.editingItem;
				this.existingImages = it.image.src.slice();
				this.version = it.version || this.versions[0];
				this.country = it.country || '';
				this.ean = it.ean || '';
				this.own = it.own === 'soon' ? 'soon' : it.own === false ? 'false' : 'true';
			}
		},
		async submit() {
			if (this.existingImages.length === 0 && this.newImages.length === 0) {
				this.error = 'Please add at least one image.';
				return;
			}
			this.error = '';
			this.submitError = '';
			const payload = {
				existingImages: this.existingImages,
				newImages: this.newImages.map((img) => img.data),
				title: this.version,
				version: this.version,
				country: this.country,
				ean: this.ean.trim(),
				own: this.own === 'soon' ? 'soon' : this.own === 'true',
			};
			this.isSubmitting = true;
			const result = await this.onSubmit({
				isEdit: !!this.editingItem,
				id: this.editingItem ? this.editingItem.id : null,
				payload,
			});
			this.isSubmitting = false;
			if (result && result.ok) {
				this.reset();
				this.$emit('close');
			} else {
				this.submitError = (result && result.error) || 'Could not save this item.';
			}
		},
		close() {
			this.reset();
			this.$emit('close');
		},
		reset() {
			this.existingImages = [];
			this.newImages = [];
			this.version = this.defaultVersion || this.versions[0];
			this.country = '';
			this.ean = '';
			this.own = 'true';
			this.error = '';
			this.isSubmitting = false;
			this.submitError = '';
		},
	},
};
</script>

<style scoped>
.modal {
	z-index: 1000;
}
.modal-card {
	width: 420px;
	max-width: 90vw;
}
</style>
